(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meoks-subcategories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initOne(sec) {
      var ticker = sec.querySelector('[data-meoks-sub-ticker]');
      var track = ticker && ticker.querySelector('.meoks-sub__track');
      if (!ticker || !track || ticker.dataset.inited) return;
      ticker.dataset.inited = '1';

      var GAP = 16;
      var PIXELS_PER_SEC = 60;
      var perView = 5;
      var cardW = 0;
      var cycleWidth = 0;
      var translate = 0;
      var paused = false;
      var jumpTarget = null;
      var lastTs = 0;

      function applyCardWidth() {
        var w = window.innerWidth;
        perView = 5;
        if (w < 1200) perView = 4;
        if (w < 900) perView = 3;
        if (w < 640) perView = 2;
        var available = ticker.clientWidth - GAP * (perView - 1);
        cardW = Math.floor(available / perView);
        ticker.style.setProperty('--card-w', cardW + 'px');
        var totalCards = sec.querySelectorAll('.meoks-sub__card').length;
        var uniqueCount = totalCards / 6;
        cycleWidth = (cardW + GAP) * uniqueCount;
      }
      applyCardWidth();
      window.addEventListener('resize', applyCardWidth);

      var cards = ticker.querySelectorAll('.meoks-sub__card');
      function markCenter() {
        var rect = ticker.getBoundingClientRect();
        var centerX = rect.left + rect.width / 2;
        var best = null, bestDist = Infinity;
        cards.forEach(function (c) {
          var cr = c.getBoundingClientRect();
          var d = Math.abs(cr.left + cr.width / 2 - centerX);
          if (d < bestDist) { bestDist = d; best = c; }
        });
        cards.forEach(function (c) { c.classList.toggle('is-center', c === best); });
      }

      function tick(ts) {
        var dt = lastTs ? (ts - lastTs) / 1000 : 0;
        if (dt > 0.1) dt = 0.016; // tab inactive guard
        lastTs = ts;

        if (jumpTarget !== null) {
          var diff = jumpTarget - translate;
          var step = (Math.abs(diff) > 4) ? diff * 0.22 : diff;
          translate += step;
          if (Math.abs(jumpTarget - translate) < 0.5) {
            translate = jumpTarget;
            jumpTarget = null;
          }
        } else if (!paused) {
          translate -= PIXELS_PER_SEC * dt;
        }

        if (cycleWidth > 0) {
          while (translate <= -cycleWidth) {
            translate += cycleWidth;
            if (jumpTarget !== null) jumpTarget += cycleWidth;
          }
          while (translate > 0) {
            translate -= cycleWidth;
            if (jumpTarget !== null) jumpTarget -= cycleWidth;
          }
        }
        track.style.transform = 'translate3d(' + translate + 'px, 0, 0)';
        markCenter();
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);

      ticker.addEventListener('mouseenter', function () { paused = true; });
      ticker.addEventListener('mouseleave', function () { paused = false; });

      sec.querySelectorAll('.meoks-sub__arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
          var base = (jumpTarget !== null) ? jumpTarget : translate;
          jumpTarget = base - dir * (cardW + GAP);
        });
      });
    }
    function initAll() {
      document.querySelectorAll('.meoks-sub').forEach(initOne);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
